import { render, staticRenderFns } from "./long-text.vue?vue&type=template&id=120fae39&"
import script from "./long-text.vue?vue&type=script&lang=js&"
export * from "./long-text.vue?vue&type=script&lang=js&"
import style0 from "./long-text.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports